import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { onErrorHandler } from "./handlers";

declare const window: any;

export const idpApi = createApi({
  reducerPath: "idp",
  baseQuery: fetchBaseQuery({
    baseUrl: window.Config?.LAMBDA_IDP ?? "https://npr-idp-wrapper.api.pens.com/",
  }),
  tagTypes: ["idp"],
  endpoints: (builder) => ({
    idp: builder.query({
      query: ({ cartId, country, postalCode }) => ({
        url: "v1/cart",
        method: "GET",
        params: { cartId: cartId, country: country, postalCode: postalCode },
      }),

      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          return data;
        } catch (error) {
          dispatch(
            onErrorHandler({
              operation: "idp",
              err: JSON.stringify(error),
              errMsg: "Error: while loading Idp data",
              api: `${window.Config.LAMBDA_IDP}v1/cart`,
            })
          );
        }
      },
    }),
  }),
});

export const { useIdpQuery } = idpApi;
